import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ImagePipe} from './image.pipe';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ImagePipe
  ],
  exports: [
    ImagePipe
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/pipes/pipes.module.ts